<template>
    <!--<div class="footer">
        <img src="../../assets/img/footer.jpg" alt="">
    </div>-->
    <div class="footer">
        <div class="content">
            <div class="contentTop">
                <div class="box">
                    <div class="contentTop-left">
                        <img src="../../assets/img/hsmd.png" alt="">
                        <div class="font">
                            <p class="title">深圳华视美达信息技术有限公司</p>
                            <p>服务热线：400-615-8816</p>
                            <p>公司地址：深圳龙岗区布吉街道环城南路5号</p>
                        </div>
                    </div>
                    <div class="contentTop-right">
                        <img src="../../assets/img/ewm.png" alt="">
                    </div>
                </div>
                <p class="line"></p>
            </div>
            <div class="contentBottom">
                <p>深圳华视美达信息技术有限公司 版权所有</p>
                <p><a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备18000950号-1</a> Copyright  2016 HassMedia.com All Rights Reserved.</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HsFooter"
    }
</script>

<style scoped>
    .footer {
        width: 100%;
        height: 369px;
        box-sizing: border-box;
        background-color: #000;
        padding: 40px 0;
    }
    .content{
        width: 1200px;
        height:auto;
        margin:0 auto;
    }
    .box{
        display: flex;
        justify-content: space-between;
    }
    .contentTop-left img{
        margin-bottom: 20px;
    }
    .contentTop-right img{
        margin-top:30px;
    }
    .font{
        font-size: 14px;
        font-family: 微软雅黑;
        color: #fff;
        line-height: 20px;
    }
     .title{
         font-size: 24px;
         margin:16px 0;
     }
     .line{
         width: 1002px;
         height:1px;
         margin-left:30px;
         margin-top:30px;
         background-color: #4b4c4e;
     }
    .contentBottom{
        margin-top: 36px;
        font-size: 14px;
        font-family: 微软雅黑;
        color: #fff;
        line-height: 20px;
        text-align: center;
    }
    .contentBottom a{
        color: #fff;
        margin-right: 20px;
    }
</style>